import update from 'immutability-helper';
import { ERROR_LOGIC_MODE_CONFIG, DEFAULT_CONFIG_SORT } from '@utils/constants';
import * as types from './types';

const initialState = {
  // mode is set by saga after checking persistence
  mode: ERROR_LOGIC_MODE_CONFIG,
  sort: DEFAULT_CONFIG_SORT,
  visible: false,
};

const switchMap = {};

switchMap[types.SET_MODE] = (state, action) => update(state, {
  mode: { $set: action.mode },
});

switchMap[types.SET_CONFIG_SORTING] = (state, action) => {
  const { sort } = action;
  return update(state, {
    sort: { $set: sort },
  });
};

switchMap[types.CHANGE_WARNING_CONTAINER_VISIBILITY] = (state, action) => {
  const { visible } = action;
  return update(state, {
    visible: { $set: visible },
  });
};

export default (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);
